module.exports = __webpack_public_path__ + "img/section4_pic1@3x.3a630376.png";